<div class="navbar-area" [ngClass]="{'sticky': isSticky}">
    <div class="container-fluid">
        <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied">
            <a class="navbar-brand mt-1" routerLink="/home">
                <div class="d-flex">
                    <img src="images/logo.png" alt="logo">
                </div>
            </a>
            <button class="navbar-toggler mt-1" type="button" (click)="toggleClass()">
                <span class="burger-menu">
                    <span class="top-bar"></span>
                    <span class="middle-bar"></span>
                    <span class="bottom-bar"></span>
                </span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="row d-flex fw-bold mt-3">
                    <h4 class="fw-bold">
                        No.1 Medical Institute
                    </h4>
                    <h6 class="fw-bold">In Surat</h6>
                </div>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a routerLink="/home" class="nav-link" routerLinkActive="active">
                            Home
                        </a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/about-us" class="nav-link" routerLinkActive="active">
                            About us
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link">
                            Gallery <i class='fas fa-angle-down mx-1'></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="nav-item cursor-pointer" *ngIf="getActiveCategoryData">
                                @for (data of getActiveCategoryData; track data) {
                                <a *ngIf="data" (click)="getGalleryList(data)" class="nav-link">
                                    {{ data.galleryCategory }}
                                </a>
                                }
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link">
                            Courses <i class='fas fa-angle-down mx-1'></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="nav-item cursor-pointer" *ngIf="courseCategoryData">
                                @for (item of courseCategoryData; track item) {
                                <a *ngIf="item" (click)="getCourseSubCategoty(item)" class="nav-link">
                                    {{ item.coursesCategoryName }}
                                </a>
                                }
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/contact" class="nav-link" routerLinkActive="active">
                            Contact
                        </a>
                    </li>
                </ul>
                <ul class="navbar-nav for-responsive">
                    <li class="nav-item">
                        <a routerLink="/home" class="nav-link" routerLinkActive="active" (click)="toggleClass()">
                            Home
                        </a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/about-us" class="nav-link" routerLinkActive="active" (click)="toggleClass()">
                            About us
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link">
                            Gallery <i class='fas fa-angle-down'></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="nav-item">
                                @for (data of getActiveCategoryData; track data) {
                                <a *ngIf="data" (click)="getGalleryList(data)" class="nav-link">
                                    {{ data.galleryCategory }}
                                </a>
                                }
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link">
                            Courses <i class='fas fa-angle-down'></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="nav-item cursor-pointer" *ngIf="courseCategoryData">
                                @for (item of courseCategoryData; track item) {
                                <a *ngIf="item" (click)="getCourseSubCategoty(item)" class="nav-link">
                                    {{ item.coursesCategoryName }}
                                </a>
                                }
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/contact" class="nav-link" routerLinkActive="active" (click)="toggleClass()">
                            Contact
                        </a>
                    </li>
                </ul>
            </div>
            <div class="others-option d-flex align-items-center">
                <div class="option-item">
                    <!-- <a routerLink="/login" class="default-btn">
                        <i class="fa-solid fa-user-tie mt-1"></i>
                        Login<span></span>
                    </a> -->
                </div>
                <div class="option-item">
                    <!-- <a routerLink="/register" class="default-btn">
                        <i class="fa-solid fa-user-plus mt-1"></i>
                        Register<span></span>
                    </a> -->
                </div>
            </div>
        </nav>
    </div>
</div>